var _defs, _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCme(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1541 232",
    width: 1541,
    height: 232,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "cmegroup-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0.87h199.55v200.38h-199.55z"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #3a464f } \n\t\t.s1 { fill: #25a9e0 } \n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m247.3 98.9v-0.5c0-48.8 36.4-88.8 88.3-88.8 31.5 0 50.6 11.1 66.9 26.8l-19.3 22.3c-13.7-12.8-28.3-21.4-47.9-21.4-32.7 0-56.5 27-56.5 60.6v0.5c0 33.6 23.8 61 56.5 61 21 0 34.5-8.5 49.2-22.3l19.3 19.6c-17.9 18.7-37.5 30.4-69.5 30.4-49.8 0-87-38.9-87-88.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m430.1 12.6h32l52.1 81.1 52.1-81.1h32v171.6h-30.1v-123.1l-54 80.9h-1l-53.5-80.4v122.6h-29.6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m630.6 12.6h126.9v26.9h-96.9v44.7h85.8v26.9h-85.8v46.1h98.1v27h-128.1z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m820.9 98.9v-0.5c0-48 36.7-88.8 88.3-88.8 29.8 0 48.2 8.4 65.8 23.3l-19.1 22.8c-13.2-11.2-26.2-18.4-47.9-18.4-31.6 0-55.5 27.8-55.5 60.6v0.5c0 35.3 23.2 61.3 58.2 61.3 16.1 0 30.8-5.2 41.3-13v-32.1h-43.7v-26.3h72.8v72.1c-16.9 14.5-41.1 26.7-71.4 26.7-53.5 0-88.8-38.2-88.8-88.2z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m1011.9 54.7h29.5v29.2c8.1-19.3 23-32.6 45.7-31.6v31.4h-1.7c-25.9 0-44 16.9-44 51.2v49.3h-29.5z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m1099.2 120.2v-0.5c0-37 29.4-67.6 69-67.6 39.6 0 68.6 30.1 68.6 67.1v0.5c0 36.8-29.3 67.4-69.1 67.4-39.4 0-68.5-30.1-68.5-66.9zm108.1 0v-0.5c0-22.8-16.4-41.7-39.6-41.7-23.7 0-38.9 18.7-38.9 41.2v0.5c0 22.6 16.4 41.7 39.4 41.7 23.9 0 39.1-18.9 39.1-41.2z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m1260.5 137.1v-82.4h29.6v73.6c0 20.1 10 31.6 27.6 31.6 17.2 0 29.1-12 29.1-32.1v-73.1h29.6v129.5h-29.6v-20.1c-8.3 12.3-20.3 22.8-40.3 22.8-29.1 0-46-19.6-46-49.8z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m1436.2 76.3c9.5-13.4 23-24.2 43.8-24.2 30.5 0 60.1 24.2 60.1 67.1v0.5c0 42.9-29.4 67.2-60.1 67.2-21.3 0-34.8-10.8-43.8-22.8v67.2h-29.6v-176.6h29.6zm36.9 1.5c-20 0-37.6 16.7-37.6 41.5v0.4c0 25 17.6 41.5 37.6 41.5 20.3 0 36.9-16 36.9-41.5v-0.4c0-25-16.8-41.5-36.9-41.5z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path",
    clipPath: "url(#cp1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s1",
    d: "m57.2 0.9h19.5c-11.7 10.9-21 25-27.5 41.5h-32.8zm38.9 41.5h-39.7c7.2-17.1 17.7-31.4 30.7-41.5h9zm46.8 0h-39.6v-41.5h9c13.1 10.1 23.5 24.4 30.6 41.5zm-1.4-41.5l41.4 41.5h-32.6c-6.5-16.5-15.8-30.6-27.5-41.5zm-102.9 96.2h-38.6v-38.1l9.2-9.4h37.3c-4.8 14.5-7.6 30.5-7.9 47.5zm57.5 0h-50.7c0.4-17.1 3.2-33.1 8.3-47.5h42.4zm7.3-47.5h42.3c5 14.4 7.9 30.4 8.2 47.5h-50.5zm49.5 0h37.2l9.4 9.4v38.1h-38.8c-0.3-17-3-33-7.8-47.5zm-152.9 54.8h38.6c0.3 17.1 3.1 33.2 8 47.8h-37.6l-9-9zm45.4 0h50.7v47.8h-42.4c-5.1-14.4-8-30.6-8.3-47.8zm100.1 47.8h-42.1v-47.8h50.5c-0.4 17.2-3.3 33.4-8.4 47.8zm15.2-47.8h38.8v38.5l-9.2 9.3h-37.6c4.9-14.6 7.7-30.7 8-47.8zm-102.8 96.9l-41.7-41.8h33c6.6 16.5 16.1 30.8 28 41.8zm-1.4-41.8h39.6v41.8h-8.4c-13.3-10.3-23.9-24.6-31.2-41.8zm86.1 0c-7.3 17.2-17.9 31.5-31.2 41.8h-8.1v-41.8zm-1.3 41.8h-19.4c11.9-11 21.4-25.3 28-41.8h33.1z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCme);
export default __webpack_public_path__ + "static/media/CME.8b3871e5673fa2e29d2c30a8080170c3.svg";
export { ForwardRef as ReactComponent };